<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'bookingModule.bookings' | translate }}
      </h1>

      <div>
        <button
          type="button"
          (click)="onClickCreate()"
          class="btn btn-primary"
          [canSee]="[accessRights.Bookings_write]"
        >
          {{ 'general.create' | translate }}
        </button>
      </div>
    </div>
  </header>

  <!-- Nav -->

  <nav attr.aria-label="{{ 'wcag.bookingMenu' | translate }}">
    <ul class="nav nav-tabs align-items-center mb-3" role="tablist">
      <!-- WCAG SKIP link -->
      <!-- <li class="nav-item">
        <a href="#bookingContent" class="nav-link visually-hidden-focusable"
          ><span>{{ 'wcag.skipNavigation' | translate }}</span></a
        >
      </li> -->
      <!-- END WCAG skip link -->
      <li class="nav-item">
        <a
          data-test-id="view-booking-calendar-button"
          href="javascript:;"
          (click)="onClickSelectedType('calendar')"
          [ngClass]="{ active: selectedType == 'calendar' }"
          class="nav-link"
          role="tab"
          [attr.aria-selected]="selectedType == 'calendar' ? 'true' : 'flase'"
          aria-controls="panel-calendar"
        >
          <i role="img" class="fa fa-calendar-alt" aria-hidden="true"></i>

          {{ 'general.calendar' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          href="javascript:;"
          data-test-id="view-booking-list-button"
          (click)="onClickSelectedType('list')"
          [ngClass]="{ active: selectedType == 'list' }"
          class="nav-link"
          role="tab"
          [attr.aria-selected]="selectedType == 'list' ? 'true' : 'false'"
          aria-controls="panel-list"
        >
          <i role="img" class="fa fa-list-alt" aria-hidden="true"></i>
          {{ 'general.list' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          href="javascript:;"
          data-test-id="view-booking-schedule-button"
          (click)="onClickSelectedType('schedule')"
          [ngClass]="{ active: selectedType == 'schedule' }"
          class="nav-link"
          role="tab"
          [attr.aria-selected]="selectedType == 'schedule' ? 'true' : 'false'"
          aria-controls="panel-schedule"
        >
          <i role="img" class="fa fa-clock" aria-hidden="true"></i>
          {{ 'general.schedule' | translate }}
        </a>
      </li>

      <li
        class="nav-item"
        *ngIf="environment.moduleConfigs.serieProposalModule.isActive"
      >
        <a
          href="javascript:;"
          data-test-id="view-booking-serie-proposals-button"
          (click)="onClickSelectedType('serieProposals')"
          [ngClass]="{ active: selectedType == 'serieProposals' }"
          class="nav-link"
          role="tab"
          [attr.aria-selected]="
            selectedType == 'serieProposals' ? 'true' : 'false'
          "
          aria-controls="panel-serieProposals"
        >
          <i role="img" class="fa fa-list" aria-hidden="true"></i>
          {{ 'serieProposalModule.serieProposals' | translate }}
        </a>
      </li>
    </ul>
  </nav>

  <!-- End Nav -->

  <div id="bookingContent">
    <booking-overview
      (openedBookingModal)="setBookingModalIsOpen($event)"
      [selectedType]="selectedType"
      *ngIf="selectedType == 'calendar'"
      id="panel-calendar"
    ></booking-overview>

    <div
      *ngIf="selectedType == 'list'"
      class="row justify-content-between"
      id="panel-list"
    >
      <div class="col-lg-auto">
        <div class="nav nav-segment nav mb-3">
          <a
            href="javascript:;"
            (click)="onClickSelectedListType('all')"
            [ngClass]="{ active: selectedListType == 'all' }"
            class="nav-link"
          >
            <i role="img" class="fa fa-cube" aria-hidden="true"></i>
            {{ 'general.all' | translate }}
          </a>

          <a
            href="javascript:;"
            (click)="onClickSelectedListType('unconfirmed')"
            [ngClass]="{ active: selectedListType == 'unconfirmed' }"
            class="nav-link"
          >
            <i role="img" class="fa fa-question-circle" aria-hidden="true"></i>
            {{ 'participationModule.isUnconfirmed' | translate }}
          </a>

          <a
            href="javascript:;"
            (click)="onClickSelectedListType('unattended')"
            [ngClass]="{ active: selectedListType == 'unattended' }"
            class="nav-link"
          >
            <i
              role="img"
              class="fa fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'general.setToNotParticipated' | translate }}
          </a>

          <a
            href="javascript:;"
            (click)="onClickSelectedListType('history')"
            [ngClass]="{ active: selectedListType == 'history' }"
            class="nav-link"
          >
            <i role="img" class="fa fa-clock" aria-hidden="true"></i>
            {{ 'general.historical' | translate }}
          </a>
        </div>
      </div>
      <form
        [formGroup]="form"
        class="col-lg-auto d-flex flex-wrap align-items-center justify-content-end"
      >
        <div class="mb-4" *ngIf="selectedListType != 'history'">
          <label class="me-3">
            {{ 'general.date' | translate }}
          </label>
          <nz-range-picker
            [nzShowTime]="false"
            [nzSize]="'large'"
            formControlName="dateRange"
          ></nz-range-picker>
        </div>
      </form>
    </div>

    <section class="booking-index card" *ngIf="selectedType == 'list'">
      <booking-table
        (onBulkAction)="onBulkAction($event)"
        (onClickRow)="onClickRow($event)"
        [bulkActions]="[BulkAction.DELETE]"
        [isLoading]="isLoading$ | async"
        [tableData]="bookings$ | async"
        [showStatus]="false"
        [showSaleItemTags]="true"
        [showTotal]="true"
        [removeSearchTerm$]="removeSearchTerm$.asObservable()"
        [showPageFooter]="true"
        [limitPage]="limit"
        [activePage]="page"
        [total]="total"
        [pageCount]="pageCount"
        (searchTerm)="onSearchTerm($event)"
        (onSelectedPage)="selectNewPage($event)"
        (onSelectLimit)="selectNewLimit($event)"
        (onSearchTerm)="onSearchTerm($event)"
      ></booking-table>
    </section>
    <div
      class="booking-index"
      *ngIf="selectedType == 'schedule'"
      id="panel-schedule"
    >
      <booking-overview-schedule
        [bookingId]="bookingId"
      ></booking-overview-schedule>
    </div>

    <serie-proposal-index
      *ngIf="selectedType == 'serieProposals'"
      id="panel-serieProposals"
    ></serie-proposal-index>
  </div>
</div>
